import Vue from 'vue'
import VueI18n from 'vue-i18n';
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify';
import axios from "./http-common";

import HeaderAuth from './components/HeaderAuth.vue';
import HeaderAnyone from './components/HeaderAnyone.vue';
import MaintHeaderAuth from './components/MaintHeaderAuth.vue';
import FooterAnyone from './components/FooterAnyone.vue';
import FooterAuth from './components/FooterAuth.vue';
import Message from './components/Message.vue';
import MessageConfirm from './components/MessageConfirm.vue';
import Information from './components/Information.vue';
import DatePicker from './components/DatePicker.vue';
import SelectPlan from './components/SelectPlan.vue';
import InputOfficerInfo from './components/InputOfficerInfo.vue';
import MemberInfo from './components/MemberInfo.vue';
import MainteVerifyRequest from './components/MainteVerifyRequest.vue';
import AuthMixinService from './mixin/AuthMixinService';
import CommonMixinService from './mixin/CommonMixinService';

import AuthMixinVfService from './mixin/AuthMixinVfService';
import VFHeaderAuth from './components/VFHeaderAuth.vue';

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.component("comHeaderAuth", HeaderAuth);
Vue.component("comHeaderAnyone", HeaderAnyone);
Vue.component("comMaintHeaderAuth", MaintHeaderAuth);
Vue.component("comFooterAnyone", FooterAnyone);
Vue.component("comFooterAuth", FooterAuth);
Vue.component("comMessage", Message);
Vue.component("comMessageConfirm", MessageConfirm);
Vue.component("comInformation", Information);
Vue.component("comDatePicker", DatePicker);
Vue.component("comSelectPlan", SelectPlan);
Vue.component("comInputOfficerInfo", InputOfficerInfo);
Vue.component("comMemberInfo", MemberInfo);
Vue.component("comMainteVerifyRequest", MainteVerifyRequest);

Vue.component("comVFHeaderAuth", VFHeaderAuth);

Vue.use(VueI18n);
Vue.mixin
Vue.mixin(AuthMixinService);
Vue.mixin(CommonMixinService);
Vue.mixin(AuthMixinVfService);
const i18n = new VueI18n({
  locale: 'ja',
  fallbackLocale: 'en',
  messages: {
    'ja': require("./common/message_ja.json"),
    'en': require("./common/message_en.json"),
  },
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
